export default "__VITE_ASSET__da214b58__"